<div class="manage-confirmation">
    <div class="mt-1 mb-2 text-center">
        {{ data.description }}
    </div>

    <div class="dialog-actions">
        <button
            (click)="onConfirm()"
            [disabled]="loading"
            class="mr-1 confirm-btn"
            color="accent"
            mat-raised-button
        >
            {{ !loading ? 'Confirm' : '' }}
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
        </button>
        <button
            mat-stroked-button
            (click)="onCancelClick()"
        >
            Cancel
        </button>
    </div>
</div>
